export const IMAGE_GALLERY_SELECTOR = ".js-image-gallery";
export const MODAL_PHOTOS_SELECTOR = "#modal-photos";
export const DETAIL_PAGE_WRAPPER_SELECTOR = ".detail-page__wrapper";
export const LISTING_INFO_SELECTOR = ".listing-info";
export const PHOTOS_TAB_SELECTOR = "#photos-tab";
export const FLOOR_PLAN_TAB_SELECTOR = "#floor-plan-tab";
export const VIRTUAL_TOUR_TAB_SELECTOR = "#virtual-tour-tab";
export const VIDEO_TAB_SELECTOR = "#video-tab";
export const MAIN_SWIPER_SLIDE_SELECTOR = "main-swiper-slide";
export const SWIPER_SLIDE_ACTIVE_SELECTOR = ".swiper-slide-active";
export const LAST_SLIDE_CONTACT_SELECTOR = ".js-last-slide-contact";
export const CLOSE_MODAL_PHOTOS_SELECTOR = "#close-modal-photos";
export const FLOOR_PLAN_SLIDE_SELECTOR = "img[data-plan=\'true\']";
export const VIRTUAL_TOUR_SLIDE_SELECTOR = "[data-virtualtour=\'true\']";
export const VIDEO_SLIDE_SELECTOR = "[data-videoslide=\'true\']";
export const TAB_ACTIVE_CLASS = "tab--active";
export const VISIBLE_CLASS = "visible";
export const BLOCKED_CLASS = "blocked";
export const FADE_OUT_CLASS = "fade-out";
export const VIEW_MORE_PROPERTY_FEATURES_SELECTOR = ".js-view-more-property-features";
export const VIEW_MORE_BUILDING_FEATURES_SELECTOR = ".js-view-more-building-features";
export const PROPERTY_FEATURE_ITEM_SELECTOR = ".js-property-feature-item";
export const BUILDING_FEATURE_ITEM_SELECTOR = ".js-building-feature-item";
export const ASIDE_CONTACT_MODAL_SELECTOR = ".js-aside-contact-modal";
export const CONTACT_FORM_SELECTOR = ".js-contact-form";
export const RIGHT_CONTENT_SELECTOR = ".detail-page__right-content";
export const CONTACT_BUTTON_SELECTOR = "#go-to-form-button";
export const CONTACT_FORM_MODAL_SELECTOR = ".contact-form-modal";
export const MODAL_FOOTER_CONTACT_BUTTON = "#modal-footer-contact-button";